<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
    <global-components />
    <app-layout-spinner />
  </div>
</template>

<script>
import GlobalComponents from "@/components/GlobalComponents.vue";
import AppLayoutSpinner from "@/components/common/ui/AppLayoutSpinner.vue";

export default {
  name: "DefaultLayout",
  components: {
    GlobalComponents,
    AppLayoutSpinner,
  },
};
</script>

<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
